<template>
  <div v-if="$i18n.countryCode == 'ID'" class="footer-support-info">
    <h3 class="title" v-text="$t('layout.footer.customerComplaintService')" />
    <p class="name" v-text="$t('layout.footer.customerComplaint.name')" />
    <p class="email" v-html="$t('layout.footer.customerComplaint.email')" />
    <p
      class="department"
      v-text="$t('layout.footer.customerComplaint.department')"
    />
    <p class="phone" v-text="$t('layout.footer.customerComplaint.phone')" />
    <hr class="hr" />
  </div>
</template>

<script>
export default {
  name: 'FooterSupportInfo'
}
</script>

<style lang="scss" scoped>
.footer-support-info {
  padding: 10px 0;
  // overwrite container padding for the hr to be full width
  width: 100vw;
  margin-left: calc(50% - 50vw);
  text-align: center;

  .hr {
    background-color: #cccccc;
    border: 0;
    height: 1px;
    margin-bottom: 0.25rem !important;
  }

  .title {
    font-weight: 700;
    font-size: 14px;
    line-height: 16px;
    text-transform: uppercase;
    margin-bottom: 5px;
  }
}
</style>
